<template>
  <IconButton
    class="lock-check-button"
    :icon="value ? 'lock' : 'lock_open'"
    color="grey"
    icon-color="black"
    variant="flat"
    :disabled="disabled"
    @click="toggle" />
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
export default {
  components: {
    IconButton
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    toggle() {
      this._value = !this._value
    }
  }
}
</script>

<style lang="scss" scoped>
.lock-check-button {
  border: 1px solid $grey12;
}
</style>